import {Record} from 'immutable';

import * as CreditActions from 'web-app/react/entities/credits/actions';
import {match, makeReducer} from 'web-app/util/redux';
import {type Credit} from 'web-app/react/entities/credits/model';

import * as Actions from './actions';

export class CreditModalState extends Record<{
    isVisible: boolean;
    isEditing: boolean;
    isSubmitting: boolean;
    isDeleting: boolean;
    billPayerId: string | null;
    institutionId: string | null;
    credit?: Credit;
    showAccountSelection: boolean;
}>({
    isVisible: false,
    isEditing: false,
    isSubmitting: false,
    isDeleting: false,
    billPayerId: null,
    institutionId: null,
    credit: undefined,
    showAccountSelection: false,
}) {}

export default makeReducer<CreditModalState>(
    [
        match(Actions.showAddCreditModal, (_, {payload}) => {
            const {billPayerId, institutionId, showAccountSelection} = payload;

            return new CreditModalState({
                isVisible: true,
                billPayerId,
                institutionId,
                showAccountSelection,
            });
        }),

        match(Actions.showEditCreditModal, (_, {payload}) => {
            const {billPayerId, institutionId, credit, showAccountSelection} = payload;

            return new CreditModalState({
                isVisible: true,
                isEditing: true,
                billPayerId,
                credit,
                institutionId,
                showAccountSelection,
            });
        }),

        match(Actions.hideCreditModal, () => new CreditModalState()),

        match(CreditActions.create, state => state.merge({isSubmitting: true})),
        match(CreditActions.createFailed, state => state.merge({isSubmitting: false})),
        match(CreditActions.createSuccess, () => new CreditModalState()),

        match(CreditActions.update, state => state.merge({isSubmitting: true})),
        match(CreditActions.updateFailed, state => state.merge({isSubmitting: false})),
        match(CreditActions.updateSuccess, () => new CreditModalState()),

        match(CreditActions.deleteCredit, state => state.merge({isDeleting: true})),
        match(CreditActions.deleteCreditFailed, state => state.merge({isDeleting: false})),
        match(CreditActions.deleteCreditAborted, state => state.merge({isDeleting: false})),
        match(CreditActions.deleteCreditSuccess, () => new CreditModalState()),
    ],
    new CreditModalState(),
);
